import { Callback } from 'Types/utilTypes'
import { ChatChannel, ChatSocketChannel, ChatSocketDataPayload, PingChannel } from 'Pages/chat'

const getChannelName = (data: ChatSocketDataPayload) => {
	if (data?.identifier) return data.identifier?.channel
	return null
}

export const chatChannelHandlerFactory = (dispatch: Callback) => {
	const channels = {
		[ChatSocketChannel.CHAT_CHANNEL]: new ChatChannel(dispatch),
		[ChatSocketChannel.PING_CHANNEL]: new PingChannel(dispatch),
	}

	return (data: ChatSocketDataPayload) => channels[getChannelName(data)]?.work(data)
}
